import { api, ApiRoutes } from '../services/ApiService'

export type BasketData = {
    individualization_id: number
    kArtikel: string
    quantity: number
    pages: { template_id: number; thumbnail: string }[]
    user_inputs: { spot_id: number; fabric: string | null }[]
    selected_extras?: string
}

export const useCartAdd = () => {
    const cart = async (element: BasketData) => {
        return await api.post(ApiRoutes.CART, undefined, element)
    }

    return {
        cart,
    }
}
